import {
  GET_INTERNSHIPS,
  GET_INTERNSHIPS_SUCCESS,
  GET_INTERNSHIPS_FAILURE,
  GET_JOB_COMPANIES,
  GET_JOB_COMPANIES_SUCCESS,
  GET_JOB_COMPANIES_FAILURE,
  GET_JOB_TYPES,
  GET_JOB_TYPES_SUCCESS,
  GET_JOB_TYPES_FAILURE,
} from "../constants";

const initialState = {
  internships: [],
  jobTypes: [],
  jobCompanies: [],
  isLoading: false,
  isTypesLoading: false,
  isCompaniesLoading: false,
  error: null,
};

export default function InternshipsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_INTERNSHIPS:
      state = {
        ...state,
        isLoading: true,
        error: null,
      };
      break;
    case GET_JOB_COMPANIES:
      state = {
        ...state,
        isCompaniesLoading: true,
        error: null,
      };
      break;
    case GET_JOB_TYPES:
      state = {
        ...state,
        isTypesLoading: true,
        error: null,
      };
      break;

    case GET_INTERNSHIPS_SUCCESS:
      state = {
        ...state,
        internships: action.payload,
        isLoading: false,
      };
      break;
    case GET_JOB_TYPES_SUCCESS:
      state = {
        ...state,
        jobTypes: action.payload,
        isTypesLoading: false,
      };
      break;
    case GET_JOB_COMPANIES_SUCCESS:
      state = {
        ...state,
        jobCompanies: action.payload,
        isCompaniesLoading: false,
      };
      break;
    case GET_INTERNSHIPS_FAILURE:
      state = {
        ...state,
        isLoading: false,
        internships: [],
        error: action.payload,
      };
      break;
    case GET_JOB_COMPANIES_FAILURE:
      state = {
        ...state,
        jobCompanies: [],
        isCompaniesLoading: false,
        error: action.payload,
      };
      break;
    case GET_JOB_TYPES_FAILURE:
      state = {
        ...state,
        jobTypes: [],
        isTypesLoading: false,
        error: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
}
